import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { LocationModalContainerDesktop } from './desktop';
import { LocationModalContainerMobile } from './mobile';

export const LocationModalContainer: React.FC = () => {
  return (
    <>
      <Responsive desktop>
        <LocationModalContainerDesktop />
      </Responsive>
      <Responsive tablet phone>
        <LocationModalContainerMobile />
      </Responsive>
    </>
  );
};
